import { DndContext, DragOverlay, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext } from '@dnd-kit/sortable';
import { Col, Flex, Row } from 'antd';
import { useState } from 'react';
import DragAndDropItem from './drag-and-drop-item';
import { IF } from 'common';

const ParentWrap = ({ children, vertical = true, wrap = true, isGridLayout = false, gap }) => {
  if (isGridLayout) {
    return <Row gutter={[16, 16]}>{children}</Row>;
  }
  return (
    <Flex wrap={wrap} vertical={vertical} gap={gap ? gap : vertical ? 8 : 16}>
      {children}
    </Flex>
  );
};

const ChildWrap = ({ children, isGridLayout = false }) => {
  if (isGridLayout) {
    return (
      <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{ touchAction: 'none' }}>
        {children}
      </Col>
    );
  }
  return <div style={{ touchAction: 'none' }}>{children}</div>;
};

const DragAndDrop = ({
  dragItems = [],
  setItemOrder = () => {},
  itemStyle = {},
  vertical = true,
  children = <></>,
  showOverlay = false,
  Item = () => {},
  itemProps = {},
  disabled = false,
  isGridLayout = false,
  gap = null,
  wrap = true,
  disabledIds = [],
}) => {
  const [activeId, setActiveId] = useState(null);

  const handleDragStart = (event) => {
    const { active } = event;
    setActiveId(active.id);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active?.id !== over?.id) {
      const oldIndex = dragItems.map((i) => i.id).indexOf(active.id);
      const newIndex = dragItems.map((i) => i.id).indexOf(over?.id);
      setItemOrder(arrayMove(dragItems, oldIndex, newIndex));
      setActiveId(null);
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  const getActiveItemData = () => {
    return dragItems?.find((item) => item?.id === activeId);
  };

  return (
    <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd} sensors={sensors}>
      <SortableContext disabled={disabled} items={dragItems}>
        <ParentWrap isGridLayout={isGridLayout} vertical={vertical} gap={gap} wrap={wrap}>
          {dragItems.map((data, index) => {
            return (
              <ChildWrap isGridLayout={isGridLayout} key={data?.id ?? index}>
                <DragAndDropItem
                  id={data?.id}
                  index={index}
                  data={data}
                  itemStyle={itemStyle}
                  Item={Item}
                  itemProps={itemProps}
                  disabledIds={disabledIds}
                />
              </ChildWrap>
            );
          })}
          {children}
        </ParentWrap>
      </SortableContext>
      <IF condition={showOverlay}>
        <DragOverlay>
          <IF condition={activeId} ELSE={null}>
            <Item id={activeId} data={getActiveItemData()} />
          </IF>
        </DragOverlay>
      </IF>
    </DndContext>
  );
};

export default DragAndDrop;
